import Vue from 'vue'
import router from '@/router/index'

const state = () => ({
  customers: null,
  customer: null,
  doctors: [],
  paymentHistory: null,
  customerListIsLoaded: false
})

const getters = { }

const actions = {
  async getCustomers ({ commit }, params) {
    const result = await Vue.$http.post('/Organization/GetList', { ...params })
    if (router.history.current.name === 'Customers') {
      commit('SET_DATA', ['customerListIsLoaded', true])
    }
    if (result?.status === 200) {
      commit('SET_DATA', ['customers', result?.data])
    }
    console.log(result)
  },
  async getCustomer ({ commit, rootGetters }, params) {
    const { id } = params // urlParams
    // const paramsStr = rootGetters.BUILD_URL_PARAMS(urlParams)
    const result = await Vue.$http.get(`/organization/${id}/details`)
    if (result?.status === 200) {
      commit('SET_DATA', ['customer', result.data])
    }
  },
  async switchQrLeadsFeature ({ commit, rootGetters }, params) {
    const { id, query } = params
    // const paramsStr = rootGetters.BUILD_URL_PARAMS(urlParams)
    const result = await Vue.$http.post(`/organization/${id}/qr-lead/${query}`)
    if (result?.status === 200) {
      return true
    }
  },
  async getPaymentHistory ({ commit }, params) {
    const { id } = params
    const result = await Vue.$http.get(`/organization/${id}/payments`)
    if (result?.status === 200) {
      commit('SET_DATA', ['paymentHistory', result?.data.$values])
      return true
    }
  },
  async addPatient ({ commit }, params) {
    const result = await Vue.$http.post('/Patients/Add', { ...params })
    if (result?.status === 200) {
      // commit('dialogs/TOGGLE_DIALOG', { name: 'addPatient', isOpen: false }, { root: true })
      console.log(`Respons: The patient was added; Status: ${result?.status}`)
      return result?.data.record
    }
  },
  async updatePatient ({ commit }, params) {
    const { id, form } = params
    const result = await Vue.$http.put(`/Patients/${id}/Update`, { ...form })
    if (result?.status === 200) {
      // commit('dialogs/TOGGLE_DIALOG', { name: 'editPatient', isOpen: false }, { root: true })
      console.log(`Respons: The patient is updated; Status: ${result?.status}`)
      return result?.data.record
    }
  },
  deactivatePatient ({ _ }, id) {
    return new Promise((resolve) => {
      Vue.$http.delete(`/Patients/${id}/Deactivate`).then((result) => {
        if (result?.status === 200) {
          resolve()
          console.log(`Respons: The patient was delete; Status: ${result?.status}`)
        }
      })
    })
  },
  activatePatient ({ _ }, id) {
    return new Promise((resolve) => {
      Vue.$http.put(`/Patients/${id}/Activate`).then((result) => {
        if (result?.status === 200) {
          resolve()
          console.log(`Respons: The patient was delete; Status: ${result?.status}`)
        }
      })
    })
  },
  async getDoctors ({ commit }) {
    const result = await Vue.$http.get('/Patients/DoctorsDropdown')
    if (result?.status === 200) {
      commit('SET_DATA', ['doctors', result?.data?.record])
    }
  },
  async vailidateEmail ({ _ }, email) {
    const result = await Vue.$http.post('/Patients/ValidateEmail', email)
    // return !!(result?.status === 200)
    return result
  }
}

const mutations = {
  SET_DATA: (state, payload) => {
    const [property, value] = payload
    Vue.set(state, property, value)
  },
  APPEND_PATIENT: (state, payload) => {
    const [property, value] = payload
    const data = Object.assign([], state[property].data.$values)
    state[property].data.$values = [...data, {
      ...value,
      name: `${value.firstName} ${value.lastName}`,
      address: `${value.line1} ${value.line2} ${value.line3} ${value.line4}`,
      number: `${value.cellPhone} ${value.homePhone} ${value.workPhone}`
    }]
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
